import { momentDtoToLocalStringByCulture } from "../../aplUtils/dateHelper";
import { translateString } from "../../translations/gridTranslationHelper";
import { AplUser } from "../../types/aplUser";
import { ColumnFilterOrDisplayType, ConfigColumns2 } from "../../types/configColumns2";
import { Culture } from "../../types/culture";

const adminUserWorkcentreRoleUsersColumns = (culture: Culture): ConfigColumns2[] => [
    { data: "userId", visible: false, title: "userId" },
    { data: "userName", className: "nowrap", width: "12%", title: "Name" },
    { data: "isLockedOut", width: "10%", title: "Locked", render: (data: AplUser) => data.isLockedOut ? translateString("rxg_Yes", culture) : translateString("rxg_No", culture) },
    {
        data: "lastLockoutDate",
        width: "12%",
        title: "lastLockoutDate",
        
        render: function (data: AplUser, type: ColumnFilterOrDisplayType | undefined) {
            return momentDtoToLocalStringByCulture(data.lastLockoutDate, culture).toString();
        }
    },
    {
        data: "PwdChange",
        className: "nowrap",
        width: "24%",
        title: "PwdDate",
        
        render: function (data: AplUser, type: ColumnFilterOrDisplayType | undefined) {
            return momentDtoToLocalStringByCulture(data.lastPasswordChangedDate, culture).toString();
        }
    },
    {
        data: "lastLoginDate",
        className: "nowrap",
        width: "8%",
        title: "LoginDate",
        
        render: function (data: AplUser, type: ColumnFilterOrDisplayType | undefined) {
            return momentDtoToLocalStringByCulture(data.lastLoginDate, culture).toString();
        }
    },
    {
        data: "siteName",
        className: "nowrap",
        width: "8%",
        title: "Site",
    }
];

const adminLinesColumns = [
    {
        data: "",
        className: "select-checkbox pl-2 pr-2",
        width: "2%",
        
        title: ""
    },
    { data: "lineDescription", className: "nowrap", width: "50%", title: "Description" },
    { data: "lineSapCode", width: "50%", title: "SapCode" },
    { data: "linePlantCode", width: "50%", title: "PlantCode", lastLockoutDate: 6 },
    {
        data: "siteName",
        className: "nowrap",
        width: "50%",
        title: "Site",
        responsivePriority: 9
    },
    {
        data: "departmentName",
        className: "nowrap",
        width: "50%",
        title: "Department",
        responsivePriority: 11
    }
];

export { adminUserWorkcentreRoleUsersColumns, adminLinesColumns };